import { useEffect, useState, useRef } from 'react';
import 'chartjs-adapter-moment';
import { Line } from "react-chartjs-2";
import Hammer from 'hammerjs' 

export default function Weathergraph(props) {
  const [data, setdata] = useState({ options: {}, graphdata: { datasets: [] } });
  const chartRef = useRef(null);
  const handleResetZoom = () => {
    if (chartRef && chartRef.current) {
      chartRef.current.resetZoom();
    }
  };

  useEffect(() => {
    if (!props.data) return;
    let label = props.data["datetime"];
    let data1 = props.data.gust;
    let data2 = props.data.wind;

    let data = {
      labels: label,
      datasets:
        [
          {
            label: "瞬間最大風速",
            type: "line",
            data: data1,
            borderColor: "#4472C4",
            backgroundColor: "#4472C4",
            borderWidth: 0.8,
            pointRadius: 0.5,
            yAxisID: 'y',
          },
          {
            label: "1分間平均風速",
            type: "line",
            data: data2,
            borderColor: "#B4C6E7",
            backgroundColor: "#B4C6E7",
            borderWidth: 0.8,
            pointRadius: 0.5,
            yAxisID: 'y2',
          },
        ],
    };
    
    let options = {
      maintainAspectRatio: false,
      scales: {
        x: {
          type: 'time',
          time: {
            unit: 'hour',
            stepSize: 1,
            displayFormats: {
                'hour': 'HH:mm'
            }
          },
          scaleLabel: {
            display: true,
          },
        },
        y: {
          display: true,
          min: 0,
          max: 30,
          position: 'left',
          ticks: {
            display: true,
          },
          title: {
            display: true,
            text: '1分間平均風速(m/sec)',
            font: {
              size: 16, 
            }
          },
        },
        y2: {
          display: true,
          min: 0,
          max: 30,
          position: 'right',
          ticks: {
            display: true,
          },
          title: {
            display: true,
            text: '瞬間最大風速(m/sec)',
            font: {
              size: 16, 
            }

          },
        },
      },
      plugins: {
        legend: {
          display: true,
          // 凡例の位置
          position: 'chartArea', // グラフ描画エリア内
          // 凡例の揃え（右端）
          align: 'start',
          labels: {
            boxHeight: 1.5,
            boxWidth: 16,
            usePointStyle: false,
            padding: 4, // 凡例項目のパディング
            font: {
              size: 16, 
            }
          },
        },
        zoom: {
          pan: {
            enabled: true,
            mode: 'xy',
            scaleMode: 'xy',
            modifierKey: "ctrl",
          },
          zoom: {
            wheel: {
              enabled: false,
            },
            pinch: {
              enabled: true,
            },
            drag: {
              enabled: true,
            },
            mode: 'xy',
            scaleMode: 'xy'
          }
        }
      }
    };
    setdata({ options: options, graphdata: data });
  }, [props.data]);

  const moveLegendPlugin = {
    id: 'moveLegendDown',
    beforeDraw: (chart) => {
      if (chart.legend) {
        chart.legend.top = 10; // グラフ内で凡例を20px下に移動
      }
    }
  };

  return (
      <div style={{ height: props.height, position: "relative",padding: "1px"}}  onDoubleClick={handleResetZoom}>
        <Line
          ref={chartRef}
          data={data.graphdata}
          options={data.options}
          plugins={[moveLegendPlugin]}
        />
        <div style={{position: "absolute", right:"1em", bottom:"1em", fontSize:"small"}}>(時刻)</div>
      </div>
  );
}
